import request from '../utils/request'

export function backlogEventApi (params) {
  return request({
    url: 'api/backlog/backlogEvent',
    method: 'get',
    params
  })
}
